module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter01"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Thank you never seems like enough, but it will have to do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thank you to Deborah Schneider, my agent and friend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thank you to Kelley Ragland, Matt Martz, and Sarah Melnyk at St. Martin’s Press/Minotaur Books for your attention to detail and good humor while dealing with one not-so-detail-oriented author who looks and sounds suspiciously like me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thank you to my posse at NYU (in no particular order of importance; you can fight that one out among yourselves): Rosie Smith, Kathy Madden, Rajni Kannan, Caroline Sorlie, Crystal "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("Jan, Joanne Staha (Nurse Joanne!), Norma Sparks, and Anna Pavlick. Wow—this bus ride is a long one and I can’t believe how much I’m enjoying it!")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thank you to my extended family and to my wonderful husband, Jim, and to my children who are rapidly becoming too old to call “children,” Dea and Patrick.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d139c4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 75
// module chunks = 0